import { Form, PageCount, Pagination, PaginationWrapper } from "olive-react-myoneui";
import RowPerPageDropdown from "./RowPerPageDropdown";

const PaginationTemplate = ({
  page,
  pageSize,
  totalPages,
  onPageChange,
  onPageSizeChange,
}) => {
  const backButtonDisabled = page <= 1;
  const nextButtonDisabled = page >= totalPages;

  const handlePageInputChange = (event) => {
    let val = Number(event.target.value);
    console.log("Page input value:", val);
    if (val && val !== page && val >= 1 && val <= totalPages) {
      onPageChange(val);
    }
  };

  return (
    <div className="page-footer">
      <div className="row-page-wrap">
        <span>Rows per page</span>
        <RowPerPageDropdown
          items={[10, 20, 50, 100]}
          value={pageSize}
          onChange={onPageSizeChange}
        />
      </div>
      <PaginationWrapper>
        <Pagination>
          <Pagination.Prev
            disabled={backButtonDisabled}
            onClick={() => onPageChange(page - 1)}
          />
          <Pagination.Item active>
            <Form.Control
              type="number"
              className="page-link"
              onClick={(event) => event.target.select()}
              value={page}
              onChange={handlePageInputChange}
            />
          </Pagination.Item>
          <Pagination.Next
            disabled={nextButtonDisabled}
            onClick={() => onPageChange(page + 1)}
          />
        </Pagination>
        <PageCount pageTotal={totalPages} />
      </PaginationWrapper>
    </div>
  );
};

export default PaginationTemplate;
